/* CraftRoot winkelwagen-pagina: upsell & verzekerd verzenden toevoegen/verwijderen, daarna pagina verversen */
(function () {
  'use strict';
  function post(url, body, btn) {
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Bezig…'; }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart error');
      return r.json();
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
      alert('Er ging iets mis, probeer het opnieuw.');
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-cr-add]');
    var rem = e.target.closest && e.target.closest('[data-cr-remove]');
    if (add) {
      e.preventDefault();
      post('/cart/add.js', { id: add.getAttribute('data-cr-add'), quantity: 1 }, add);
    } else if (rem) {
      e.preventDefault();
      post('/cart/change.js', { id: rem.getAttribute('data-cr-remove'), quantity: 0 }, rem);
    }
  });
})();
